<div class="login" *ngIf="logged ==undefined || logged==null">
    <div id="eq-loader">
        <div class="eq-loader-div">
            <div class="eq-loading dual-loader mx-auto mb-5"></div>
        </div>
    </div>
    
    <form class="form-login" [formGroup]="loginForm" novalidate>
        <!-- <div class="row col-lg-12">
            <a href="../index/" class="home-link"> <span class="fa fa-home"></span> Accueil</a>
        </div> -->
        <div class="row">
            <a href="/index" style="margin-top: -25px;color:rgb(237, 237, 237)">
                <i class="fas fa-home"></i> Accueil</a>
            <div class="col-md-12 text-center mb-4">
                <a href="../index"><img alt="logo" src="../../assets/img/suivitim_img/my-image.png" width="50%"></a>
                
            </div>
            <div class="col-md-12" *ngIf="connexionLoad">
                <div  class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                    margin-bottom: 15%;"></div>
            </div>
            <div class="col-md-12" *ngIf="!connexionLoad">
                <div class="social text-center">
                    <h4 class="text-primary">
                        <b>
                            <!-- Authentication -->
                        </b>
                    </h4>
                </div>
                <!-- <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                    <input class="mdl-textfield__input" type="text" id="inputLGEx"name="login" formControlName="login" [ngClass]="{'is-invalid':loginForm.get('login')?.touched
                    && loginForm.get('login')?.invalid}">
                    <label class="mdl-textfield__label" for="inputLGEx">Identifiant...</label>
                </div>
                <div class="md-form form-lg mb-3">
                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" id="show_hide_password">
                        <input type="password" id="inputPassword" class="mdl-textfield__input" required
                            name="password" formControlName="password" [ngClass]="{'is-invalid':loginForm.get('password')?.touched
                            && loginForm.get('password')?.invalid}" (keyup.enter)="login($event)">
                        <label class="mdl-textfield__label" for="inputPassword">Mot de passe...</label>
                        <div class="input-group-addon">
                            <a href="javascript:void(0)" >
                                <img src="../../assets/img/suivitim_img/hide_pass.png" style="width:20px !important;" (click)="showHidePass('show')" id="hide_pass">
                                <img src="../../assets/img/suivitim_img/show_pass.gif" style="width:25px !important;" (click)="showHidePass('hide')" id="show_pass">
                            </a>
                        </div>
                    </div>    
                </div>        -->
                <!-- Pour l'input de l'identifiant -->
                <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                    <input class="mdl-textfield__input" type="text" id="inputLGEx" name="login" 
                        formControlName="login" required
                        [ngClass]="{'is-invalid':loginForm.get('login')?.touched && loginForm.get('login')?.invalid}">
                    <label class="mdl-textfield__label" for="inputLGEx">Identifiant</label>
                </div>

                <!-- Pour l'input du mot de passe -->
                <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" id="show_hide_password">
                    <input type="password" id="inputPassword" class="mdl-textfield__input" required
                        name="password" formControlName="password" 
                        [ngClass]="{'is-invalid':loginForm.get('password')?.touched && loginForm.get('password')?.invalid}" 
                        (keyup.enter)="login($event)">
                    <label class="mdl-textfield__label" for="inputPassword">Mot de passe</label>
                    <div class="input-group-addon">
                        <a href="javascript:void(0)">
                            <img src="../../assets/img/suivitim_img/hide_pass.png" style="width:20px !important;" 
                                (click)="showHidePass('show')" id="hide_pass">
                            <img src="../../assets/img/suivitim_img/show_pass.gif" style="width:25px !important;" 
                                (click)="showHidePass('hide')" id="show_pass">
                        </a>
                    </div>
                </div>
                <div class="checkbox d-flex justify-content-center mb-3">
                    <div class="custom-control custom-checkbox mr-3">
                        <input type="checkbox" class="custom-control-input" id="customCheck1" name="session" formControlName="session" 
                            value="remember-me">
                        <label class="custom-control-label text-success pt-1" for="customCheck1" 
                            style="color:black!important;font-weight: 600;">Se souvenir de moi</label>
                    </div>
                </div>
                <button type="submit" class="btn btn-gradient-success btn-rounded btn-block" 
                    (click)="login($event)" (keyup.enter)="login($event)" [disabled]="loginForm.invalid">Se connecter</button>
                <div  class="division mt-2 mb-0" id="error" style="display: none;">
                    <div class="alert alert-danger br-50" role="alert"> 
                        <!-- <i class="flaticon-cancel-12 close" data-dismiss="alert"></i>  -->
                        Authentication échouée</div>
                </div>
            </div>
        </div>
    </form>
</div>